import { Box, Flex } from "@chakra-ui/react";
import ExpertsList from "../../../components/experts/ExpertsList";
import ExpertsPage from "../../../components/experts/ExpertsPage";
import Header from "../../../components/header/Header";
import IsDesktop from "../../../utils/IsDesktop";

const Experts = () => {
    const isDesktop = IsDesktop()
    return (
        <Box>
            <Header title='Experts' />
            <Flex className={`flex-col ${isDesktop ? 'max-h-[95vh] pb-10 overflow-y-scroll' : ''}`}>
                <Box className="p-4 bg-[#f0f0f0] ">
                    <ExpertsList />
                </Box>
            </Flex>
        </Box>
    );
}
 
export default Experts;